import { Check, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { useRowSelection } from "@/components/data-table/hooks/useRowSelection";
import { useRowSelectionCount } from "@/components/data-table/hooks/useRowSelectionCount";

export const ListSelectedRowsStatus = () => {
  const { t } = useTranslation();
  const { clear } = useRowSelection();
  const count = useRowSelectionCount();

  if (count === 0) {
    return null;
  }

  return (
    <>
      <Button variant="outline" size="sm" onClick={clear}>
        <X className="w-4 h-4" />
        <span>{t("table.clearSelection")}</span>
      </Button>
      <span className="flex items-center gap-2 shrink-0">
        <Check className="w-4 h-4" />
        <span>
          {t("table.selectedRowsCount", {
            count,
          })}
        </span>
      </span>
    </>
  );
};
